<template>
  <section id="sec">

    <div class="api_notice">
      <br>
      <div style=" font-size: 2.15em; font-family: arial, sans-serif; font-weight: 700;">
        &nbsp;&nbsp;バージョンアップしたAPI「v2」のリファレンスについて<br><br>
      </div>

      <div style="font-size: 1.7em; line-height: 1.6;">
        ダイレクトクラウドでは、本サイトに公開されている「v1」のAPIのほかに、バージョンアップし た「v2」のAPIを提供しています。<br>
        「ファイルダウンロード」「ファイルコピー」などの一部のAPIのみ、v2を提供していますが、<br>
        そのほかのAPIについても、順次v2にバージョンアップしていく予定です。<br>
        v2のAPIを利用する場合は、<a href="https://link.directcloud.jp/apireference" target="_blank" >こちら</a>にアクセスして、PDFファイルを参照してください。<br>
      </div>
    </div>

    <h1>ユーザー APIリファレンス</h1>
    <div class="container">
      <div v-for="tag of userXTags">
        <HomeList
          v-if="!modelsList.includes(tag)"
          :title="tag"
          :parsed="userParser(userDoc2, tag)"
          pilot="ユーザー"
        ></HomeList>
      </div>
    </div>

    <h1>管理者 APIリファレンス</h1>
    <div class="container">
      <div v-for="tag of managerTags">
        <HomeList
          :title="tag"
          :parsed="managerParser(managerDoc2, tag)"
          pilot="管理者"
        ></HomeList>
      </div>
    </div>
    <br> <br> <br>
    <div class="api_plan">
      <br>
      <div style=" font-size: 2.15em; font-family: arial, sans-serif; font-weight: 700;">
        &nbsp;&nbsp;注意事項<br><br>
      </div>

      <div style="font-size: 1.7em; line-height: 1.6;">
        ・WebブラウザからDirectCloud APIを呼び出すことはできません。<br>
        ・本リファレンスに掲載されているAPIはDirectCloudで使用されているAPIの一部です。<br>
        &nbsp;&nbsp;&nbsp;今後お客様からのご要望によりDirectCloud APIの公開範囲を拡大する可能性もございます。<br>
        ・以下は、v2のAPIとして提供しています。<br>
        &nbsp;&nbsp;&nbsp;「DirectCloud 電帳法対応」および「DirectCloud AI」に関連するAPI<br>
        &nbsp;&nbsp;&nbsp;「変更されたノードの照会」のAPI
      </div>
    </div>

  </section>
</template>

<script>
// Components
import HomeList from '../components/HomeList';

// Functions
import { userParser, managerParser, getXTags, getTags } from '../data/userData';

export default {
  name: 'Home',
  components: {
    HomeList,
  },
  props: {
    userDoc2: Object,
    managerDoc2: Object,
  },
  data: function () {
    return {
      userXTags: getXTags(this.userDoc2),
      managerTags: getTags(this.managerDoc2),
      modelsList: this.userDoc2['x-tagGroups'].filter(
        (item) => item.name === 'Models',
      )[0].tags,
      qnaAfterHref: '/support/qna_after',
      qnaBeforeHref: '/support/qna_before',
    };
  },
  methods: {
    userParser,
    managerParser,
  },
};
</script>

<style scoped lang="scss">
h1 {
  text-align: center;
  margin: 2em 0 0.8em 0;
  font-size: 2.2rem;
  font-weight: 400;
  color: #151f26;
  line-height: 1.1;
  font-family: 'arial', 'Meiryo', 'MS PGothic', sans-serif !important;
}
.container {
  height: 100%;
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(3, minmax(20%, 50%));
  //grid-auto-columns: minmax(10px, auto);
  grid-template-rows: repeat(2, minmax(auto, auto)); // rows 크기 자동조절
  //grid-auto-rows: minmax(20vh, auto);
  gap: 1.5rem;
  grid-auto-flow: dense;
}

.api_notice {
  margin-top: 20px;
}

.api_notice,
.api_plan {
  width: 1100px;
  border: 1px solid;
  border-radius: 10px;
  padding: 20px;
}

//.sec {
//  display: flex;
//  flex-wrap: wrap; // flex 일때 다음줄로 자연스럽게 넘어가게함
//}
</style>
